export const iconFontAwesomeMedicalHealthBone = (
	<i className="fa-solid fa-bone"></i>
);
